module.exports = __webpack_public_path__ + "img/Arrow_Up.b7bd498a.svg";